import { create } from "zustand";
import { persist } from "zustand/middleware";
import { useProfiles } from "./profileStore.js";

/**
 * Where the app opens (owner, 2026-10-12: TV-style start). Per profile, kept on this device.
 * "home" is Netflix-style Home and the default for every profile; "tv" opens straight into
 * the profile's last live channel, full screen. Only the Android app offers the choice.
 */
export type StartScreen = "home" | "tv";

interface StartScreenStore {
  /** profile id → its choice. A profile that has never chosen is not listed: it starts on Home. */
  byProfile: Record<string, StartScreen>;
  setStartScreen: (profileId: string, value: StartScreen) => void;
}

export const useStartScreen = create<StartScreenStore>()(
  persist(
    (set) => ({
      byProfile: {},
      setStartScreen: (profileId, value) => set((state) => ({ byProfile: { ...state.byProfile, [profileId]: value } })),
    }),
    { name: "slique-start-screen", version: 1 },
  ),
);

export function startScreenFor(profileId: string | undefined, byProfile: Record<string, StartScreen>): StartScreen {
  return (profileId && byProfile[profileId]) || "home";
}

// A removed profile takes its choice with it.
useProfiles.subscribe((state) => {
  const { byProfile } = useStartScreen.getState();
  const kept = Object.fromEntries(Object.entries(byProfile).filter(([id]) => state.profiles.some((p) => p.id === id)));
  if (Object.keys(kept).length !== Object.keys(byProfile).length) useStartScreen.setState({ byProfile: kept });
});
